// extracted by mini-css-extract-plugin
export var closeButton = "_me-1";
export var closeX = "_me-3";
export var container = "_me-0";
export var image = "_me-2";